<template>
  <div class="zskf-dialog-wrap">
    <CvipDialog @btnClick="vipBuy()" @close="close()" :title="title" :btnTxt="btnTxt" v-if="!(cvipMes.cvipstate==1||cvipMes.cvipstate==10)">
      <div class="des">尊贵的会员：
        <div class="des-inline">
          <p class="des-in">遇到问题怎么办？</p>
          <p class="des-in">新功能不理解？不会用？</p>
          <p class="des-light">开通会员即刻享受58专属客服，保证24小时内解答您的疑问？</p>
        </div>
      </div>
      <div class="zskf-bg"><img class="zskf-bg-img" src="../../../../assets/imgs/pri-zskf.png"></div>
    </CvipDialog>
    <CvipDialog @btnClick="vipBuy()" @close="close()" :title="title1" :btnTxt="btnTxt1" v-else>
      <div class="des">尊贵的会员：
        <div class="des-inline">
          <p class="des-in">网页版暂不支持问题反馈，如有问题请前往手机客户端进行反馈。</p>
          <p class="des-light">反馈路径：58APP-我的-我的求职-会员中心-专属客服-填写反馈</p>
        </div>
      </div>      
      <div class="downloadQRcode"></div>
    </CvipDialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import CvipDialog from "./common/CvipDialog"
export default {
  name: 'zskfDialog',
  components: {
    CvipDialog
  },
  data () {
    return {
      title: '专属客服',
      btnTxt: '开通会员尊享特权',
      title1: '专属客服',
      btnTxt1: '知道了',
      title2: '',
      btnTxt2: '立即体验'
    }
  },
  mounted(){
    window.clickLog && window.clickLog(`from=pc-cvip-zskf-tanchuang-show-${this.cvipMes.cvipstate}`)
  },
  methods: {
    // 点击支付按钮
    vipBuy () {
      window.clickLog && window.clickLog(`from=pc-cvip-tqtc-zskf-ljkt-${this.cvipMes.cvipstate}`)
      this.$emit("buyDialog")
    },
    close () {
      window.clickLog && window.clickLog(`from=pc-cvip-tqtc-zskf-close-${this.cvipMes.cvipstate}`)
      this.$emit("closeDialog")
    }
  },
  computed: mapGetters({
    cvipMes: 'cvipMes',
    rightUsed: 'rightUsed' //4：黄金亮点 5：置顶 10：尊贵标识 11：个人认证 12：求职分析 13：免费刷新 14：求职保障 15：意外保险
  })
}
</script>

<style lang="scss" scoped>
.tit{
  margin-top:80px;
}
.zskf-bg{
  width: 606px;
  height: 290px;
  margin: 20px auto 0;
  overflow: hidden;
  text-align: center;
}
.downloadQRcode{
   margin: 0 auto;
    width: 200px;
    height: 197px;
    margin-top: 50px;
    background-image: url(http://img.58cdn.com.cn/m58/app58/m_static/apiwap/img/qrcode.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
}
.zskf-bg-img{
  width: 300px;
  height: 240px;
}
.des-in{
  font-size: 14px;
  color: #AAAAAA;
  line-height: 20px;
  margin-top: -2px;
  margin-bottom: 4px;
}
.des-inline{
    display: inline-block;
    vertical-align: text-top;
}
.des-light{
  font-size: 14px;
  color: #C89543;
  line-height: 22px;
}
.des-use{
  width:100%;
  display:inline-block;
  text-align:center;
}
.tit{
  margin: 55px 0 8px;
  font-size: 24px;
  color: #333;
  line-height: 33px;
  text-align:center;
}
.tit-names{
  font-size: 24px;
  color: #D4B277;
  line-height: 33px;
}
</style>



// WEBPACK FOOTER //
// ZskfDialog.vue?f29f39d4